import { CartGradeOptionDiscountUrl, CartPrerequisiteUrl } from "../directives/utilities/urls";

export default function uCInetIDList() {
    return {
        uCINetIdList: [],
        passedSessionId: 'test',
        byPassPrerequisites: false,
        selectedUciNetOptionSerialId: '',
        selectedAcademicSessionValue: '',
        selectedAcademicYearValue: '',
        selectedAcademicTermValue: '',
        showErrorMesage: false,
        showLoader: false,
        detailPageUrl: '',
        passedUCINetoptions: [{ serialId: '', academicSession: '', academicTerm: '', academicYear: '' }],
        isOptionSelected: 0,
        isOptionSelectedError: '',
        failCount: 0,
        successCount:0,
        formatDate(dateValue) {

            const options = { month: "long", day: "numeric", year: "numeric" };
            const formattedDate = new Date(dateValue).toLocaleDateString(
                undefined,
                options
            );
            return formattedDate;
        },
        handleSelectClick(item) {
            var presentCount = 0;
            for (let i = 0; i < this.passedUCINetoptions.length; i++) {
                if (this.passedUCINetoptions[i].academicTerm.toUpperCase() + "" + this.passedUCINetoptions[i].academicYear != item.academicTerm.toUpperCase() + "" + item.academicYear)
                {
                    presentCount = 0;
                }
                if (this.passedUCINetoptions[i].academicTerm.toUpperCase() + "" + this.passedUCINetoptions[i].academicYear == item.academicTerm.toUpperCase() + "" + item.academicYear)
                {
                    presentCount += 1;
                    this.passedUCINetoptions.splice(i, 1);
                    this.passedUCINetoptions.push({ serialId: item.serialId, academicSession: item.academicSession, academicTerm: item.academicTerm.toUpperCase(), academicYear: item.academicYear });
                }
               
            }
           if (presentCount == 0) {
               this.passedUCINetoptions.push({ serialId: item.serialId, academicSession: item.academicSession, academicTerm: item.academicTerm.toUpperCase(), academicYear: item.academicYear });
               this.isOptionSelected += 1;
           }
          
        },
        bindUCINetIdList() {

            fetch('/api/Checkout/GetUCINetIdList', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response != undefined && response.isSuccess) {
                        if (response.hasUciNetOptions && response.uciNetOptions.length > 0) {
                            Array.prototype.push.apply(this.uCINetIdList, response.uciNetOptions);
                            this.byPassPrerequisites = response.bypassPrerequisites ? response.bypassPrerequisites : false;
                           // this.selectedUciNetOptionSerialId = response.selectedUciNetOptionSerialId ? response.selectedUciNetOptionSerialId : "";

                            for (const item of this.uCINetIdList) {
                               if (item.isSelected==true) {
                                   this.passedUCINetoptions.push({ serialId: item.serialId, academicSession: item.academicSession, academicTerm: item.academicTerm.toUpperCase(), academicYear: item.academicYear });
                               }
                            }
                        } else if (response.bypassPrerequisites) {
                            window.location.href = CartGradeOptionDiscountUrl;
                        } else if (!response.hasUciNetOptions || response.uciNetOptions.length <= 0) {
                            window.location.href = CartPrerequisiteUrl;
                        }
                       
                    } else {
                        this.showErrorMesage = "An unknown error has occurred. Please try again later."
                    }

                });
        },
        submitUCINetOptions() {
            
            
            if (this.passedUCINetoptions.length == 1) {
                this.showErrorMesage = "Please select at least one option for term";
                return false;
            }
            else {
                this.showErrorMesage = "";
            }
            //for (let i = 0; i < this.uCINetIdList.length; i++) {
            //    for (let j = 1; j < this.passedUCINetoptions.length; j++) {
            //        if (this.uCINetIdList[i].academicTerm + "" + this.uCINetIdList[i].academicYear == this.passedUCINetoptions[j].academicTerm + "" + this.passedUCINetoptions[j].academicYear) {
            //            this.isOptionSelected -= 1;
            //        }
            //        else {
            //            this.isOptionSelected += 1;
            //        }
            //    }
            //}
            var selectedOptionsCount = (this.uCINetIdList.length) / (this.passedUCINetoptions.length-1);
            if (selectedOptionsCount !=2) {
                this.showErrorMesage = "Please select UCI Net ID option for each term";
                return false;
            }
            else
            {
                this.showErrorMesage = "";
                for (let k =1; k < this.passedUCINetoptions.length; k++) {
                    fetch('/api/checkout/saveucinetoption', {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            SerialId: this.passedUCINetoptions[k].serialId,
                            AcademicSession: this.passedUCINetoptions[k].academicSession,
                            AcademicTerm: this.passedUCINetoptions[k].academicTerm.toUpperCase(),
                            AcademicYear: this.passedUCINetoptions[k].academicYear,
                        })
                    })
                        .then(response => {
                            if (response.ok) {
                                return response.json()
                            }
                        }).then(response => {

                            if (response.isSuccess) {
                                this.successCount += 1;

                            }
                            else {
                                this.failCount += 1;
                            }
                        });
                }
            }
            
            if (this.failCount > 0) {
                this.showErrorMesage = "Something went wrong."
            }
            else {
                this.showErrorMesage = "";
                window.location.href = CartPrerequisiteUrl;
            }
        },
        init() {
            this.bindUCINetIdList();
            

        }
    }
}